const SET = 'patron/app-config/SET';

export default {
  SET,
};
